export class MessageNotificationsController {
    static $inject = ['$scope', 'ngToast', 'close', 'notifications'];
    constructor($scope, ngToast, close, notifications) {
        'ngInject';
        this.$scope = $scope;
        this.ngToast = ngToast;
        this.close = close;
        this.notifications = notifications;
    }
}
MessageNotificationsController.$inject = ['$scope', 'ngToast', 'close', 'notifications'];
